import { authSelectors } from 'ducks/auth'
import { permissionsSelectors } from 'ducks/permissions'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useResourceService } from 'Studio/hooks/useResourceService'
import { RootState } from 'types/state'

export function usePrewarmStudioResources(): void {
  const resourcesService = useResourceService()
  const orgId = useSelector(authSelectors.getOrgId)
  const isLoggedInProAndMfaVerified = useSelector(authSelectors.getIsLoggedInProAndMfaVerified)

  const { allowView } = useSelector((state: RootState) => permissionsSelectors.getPermissionByKey(state, 'project'))

  useEffect(() => {
    if (!orgId) return
    if (!allowView) return
    if (!isLoggedInProAndMfaVerified) return

    const prewarm = () => {
      resourcesService.prewarmStudioProfileResources(orgId).catch((err: unknown) => {
        console.warn('[usePrewarmStudioResources] prewarm failed:', err)
      })
    }

    if ('requestIdleCallback' in window) {
      const id = (window as Window).requestIdleCallback(prewarm, { timeout: 15000 })
      return () => (window as Window).cancelIdleCallback(id)
    }

    //@ts-ignore
    const id = window.setTimeout(prewarm, 1000)
    return () => window.clearTimeout(id)
  }, [orgId, isLoggedInProAndMfaVerified, allowView])
}
